<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 牌证申请审核
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="organ-box">
                <el-button
                    type="primary"
                    class="handle-del mr10"
                    @click="addApply('addApplyform')"
                >添加申购申请</el-button>
               <el-button
                   type="primary"
				   icon="el-icon-circle-check"
                   class="handle-del mr10"
                   @click="passApply()"
               >批量通过</el-button>
			   <el-button
			       type="primary"
				   icon="el-icon-circle-close"
			       class="handle-del mr10"
			       @click="fallbackApply()"
			   >批量退回</el-button>
             
            </div>
            <el-table
                :data="applyListData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="applicantOrganizationName" label="申请单位" align="center"></el-table-column>
                <el-table-column prop="area" label="区域" align="center"></el-table-column>
				<el-table-column prop="createTimeStr" label="申请时间" align="center" width="100px"></el-table-column>
				<el-table-column label="车牌" align="center">
				  <el-table-column
				    prop="licenseNumber"
				    label="数量"
					align="center">
				  </el-table-column>
				  <el-table-column
				    prop="licensePrice"
				    label="价格(元)"
					align="center">
				  </el-table-column>
				</el-table-column>
				
				<el-table-column label="设备档案证(登记证)" align="center">
				  <el-table-column
				    prop="equipmentFilesNumber"
				    label="数量"
					align="center">
				  </el-table-column>
				  <el-table-column
				    prop="equipmentFilesPrice"
				    label="价格(元)"
					align="center">
				  </el-table-column>
				</el-table-column>
				
				<el-table-column label="安全培训证(操作证)" align="center">
				  <el-table-column
				    prop="certificateNumber"
				    label="数量"
					align="center">
				  </el-table-column>
				  <el-table-column
				    prop="certificatePrice"
				    label="价格(元)"
					align="center">
				  </el-table-column>
				</el-table-column>
				
				<el-table-column prop="totalAmount" label="合计金额(元)" align="center"></el-table-column>
               
                
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
						<el-button type="text">
							<router-link :to="'/seeorganlicenseapply/'+scope.row.organizationLicenseApplyId" style="color: #409EFF;">
							查看
							</router-link>
						</el-button>
						<el-button
						    type="text"
							icon="el-icon-circle-check"
						    @click="passApply(scope.row)"
						>通过</el-button>
                        <el-button
                            type="text"
							icon="el-icon-circle-close"
                            @click="fallbackApply(scope.row)"
                        >退回</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

		<!-- 添加 -->
		<el-dialog class="branch-dialog question-dialog" title="牌照申购表" :visible.sync="addApplyVisible" width="600px">
		    <el-form ref="addApplyform" :model="addApplyform" :rules="addapplyrules">
		        <el-form-item label="区域" prop="provincecityid" >
		            <el-cascader :options="cityList" :props="optionProps"  @change="handleChange" v-model="addApplyform.provincecityid"></el-cascader>
		        </el-form-item>
				<div class="apply-box">
					<p>
						<el-form-item label="车牌数量" prop="licenseNumber">
						    <el-input v-model="addApplyform.licenseNumber" ></el-input>
						</el-form-item>
					</p>
					<p>
						<el-form-item label="车牌金额(元)" prop="licensePrice">
						    <el-input v-model="addApplyform.licensePrice"></el-input>
						</el-form-item>
					</p>
				</div>
				<div class="apply-box">
					<p>
					 <el-form-item label="申请牌照起始号" prop="startNumber">
		        		    <el-input v-model="addApplyform.startNumber" ></el-input>
		        		</el-form-item>
					</p>
				</div>
		        <div class="apply-box">
		        	<p>
		        		<el-form-item label="设备档案证/登记证数量" prop="equipmentFilesNumber">
		        		    <el-input v-model="addApplyform.equipmentFilesNumber" ></el-input>
		        		</el-form-item>
		        	</p>
		        	<p>
		        		<el-form-item label="证书金额(元)" prop="equipmentFilesPrice">
		        		    <el-input v-model="addApplyform.equipmentFilesPrice" ></el-input>
		        		</el-form-item>
		        	</p>
		        </div>
				<div class="apply-box">
					<p>
						<el-form-item label="培训合格证/施工操作证数量" prop="certificateNumber">
						    <el-input v-model="addApplyform.certificateNumber"></el-input>
						</el-form-item>
					</p>
					<p>
						<el-form-item label="证书金额(元)" prop="certificatePrice">
						    <el-input v-model="addApplyform.certificatePrice"></el-input>
						</el-form-item>
					</p>
				</div>
				<el-form-item label="合计金额(元)" prop="totalAmount">
					 <el-input v-model="addApplyform.totalAmount" ></el-input>
				</el-form-item>
				
				
		    </el-form>
			
		    <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="saveApplyadd('addApplyform')">确 定</el-button>
		        <el-button @click="addApplyVisible = false">取 消</el-button>
		    </span>
		</el-dialog>
        
    </div>
</template>

<script>
import {listProvinceCitys,getCityStartNumber,listOrganizationLicenseApplyExamines,saveOrganizationLicenseApply,examineOrganizationLicenseApply,fetchData } from '../api/index';
export default {
    name: 'organizationlicenseapply',
    data() {
        return {
			number:'',
			cityList:[],//省市数据
			optionProps: {
				// TODO
					value: 'id',
					label: 'name'
			},   //省市联动重命名指向
            query: {
                pageIndex: 1,
                pageSize: 10
            },
            applyListData: [],   //列表数据
			addApplyform:{
				provincecityid:[],
				licenseNumber:'',
				licensePrice:'',
				equipmentFilesNumber:'',
				startNumber:'',
				equipmentFilesPrice:'',
				certificateNumber:'',
				certificatePrice:'',
				totalAmount:''
			},//添加
			addapplyrules: {
				provincecityid: [
					{ required: true, message: '请输入分支机构名称', trigger:  ['blur', 'change']  }
				],
				licenseNumber:[
					{ required: true, message: '请输入车牌数量', trigger:  ['blur', 'change']  },
				],
				licensePrice:[
					{ required: true, message: '请输入车牌金额', trigger:  ['blur', 'change']  }
				],
				startNumber:[
					{ required: true, message: '请输入申请车牌起始号', trigger:  ['blur', 'change']  }
				],
				equipmentFilesNumber:[
					{ required: true, message: '请输入设备档案证/登记证数量', trigger:  ['blur', 'change']  }
				],
				equipmentFilesPrice:[
					{ required: true, message: '请输入证书金额', trigger:  ['blur', 'change']  }
				],
				certificateNumber:[
					{ required: true, message: '请输入安全培训班/施工操作证数量', trigger:  ['blur', 'change']  }
				],
				certificatePrice:[
					{ required: true, message: '请输入证书金额', trigger:  ['blur', 'change']  }
				],
				totalAmount:[
					{ required: true, message: '请输入合计金额', trigger:  ['blur', 'change']  }
				],
			},  //添加表单验证
			// organizationLicenseApplyIdsArr:[],   //分支机构牌证申购申请表id集合   用于通过or回退
            multipleSelection: [],    //多选数据
			
			
			
			addApplyVisible:false,  //添加
            pageTotal: 0,
        };
    },
    created() {
		var that = this;
		//省市
		listProvinceCitys({
		}).then(res => {
		    // 获取数据成功后的其他操作
			that.cityList = res.data;
		});
        this.getlistOrganizationLicenseApplyExamines();
    },
    methods: {
	// 牌照起始号
        handleChange(value) {
           	let cityId = value[1]
		       getCityStartNumber({},{
                        cityId:cityId
                    }).then(res => {
                     // 获取数据成功后的其他操作
                        console.log(res)
                      if(res.code == 0){
						  this.number = res.message
                        this.addApplyform.startNumber = res.message
					  }
                    });
        },
		// 获取列表数据
		getlistOrganizationLicenseApplyExamines(){
			listOrganizationLicenseApplyExamines({
				current: this.query.pageIndex,                    
				size: this.query.pageSize              
			}).then(res => {
				// 获取数据成功后的其他操作
				this.applyListData = res.data.records;  
				this.pageTotal = res.data.total;
			});
		},
		
		//点击添加按钮事件
		addApply(formName){
			this.addApplyVisible = true;
			//重置表单数据
			this.$nextTick(()=>{
			  this.$refs.[formName].resetFields();
			})
		},
		// 添加保存
		saveApplyadd(formName) {
			console.log(this.addApplyform,111111)
			this.$refs[formName].validate((valid) => {
			  if (valid) {
				console.log(this.addApplyform.provincecityid)
				console.log(this.addApplyform.provincecityid[0],this.addApplyform.provincecityid[1]) 
				this.addApplyform.provinceId = this.addApplyform.provincecityid[0];
				this.addApplyform.cityId = this.addApplyform.provincecityid[1];
				  saveOrganizationLicenseApply(this.addApplyform).then(res => {
					  this.getlistOrganizationLicenseApplyExamines();
					  if(res.code == 0){
						  // 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
							this.addApplyVisible = false;
					  }else if(res.code == 1){
						  this.$message({
						    message: res.message,
						    type: 'warning'
						  });
					  }else{
						  this.$message({
						    message: '报错啦!',
						    type: 'warning'
						  });
					  }
					   
				  })
			  } else {
				return false;
			  }
			});
		  },
		
		// 查看
		
		
		// 多选操作
		handleSelectionChange(val) {
		    this.multipleSelection = val;
			console.log(this.multipleSelection)
		},
		  // 通过
		  passApply(row){
			var that = this;
			// 分支机构牌证申购申请表id集合   用于通过or回退
			var organizationLicenseApplyIdsArr = [];  
			if(row){
				organizationLicenseApplyIdsArr.push(row.organizationLicenseApplyId);
			}else{
				if(that.multipleSelection.length>0){
					for(var i in that.multipleSelection){
						organizationLicenseApplyIdsArr.push(that.multipleSelection[i].organizationLicenseApplyId);
					}
				}else{
					this.$message({
					  message: '没有选择要通过的选项哦',
					  center: true
					});
					return false;
				}
			}
			
			this.$confirm('确定要通过吗？', '提示', {
			    type: 'warning'
			}).then(() => {
			        examineOrganizationLicenseApply({
			        	isPass:1,                    
			        	organizationLicenseApplyIds: organizationLicenseApplyIdsArr              
			        }).then(res => {
			        	// 获取数据成功后的其他操作
						 this.query.pageIndex = 1;
			        	this.getlistOrganizationLicenseApplyExamines();
			        	console.log(res)
			        });
			}).catch(() => {});
			
			
			
		  },
		  // 回退
		fallbackApply(row){
			var that = this;
			// 分支机构牌证申购申请表id集合   用于通过or回退
			var organizationLicenseApplyIdsArr = [];  
			if(row){
				organizationLicenseApplyIdsArr.push(row.organizationLicenseApplyId);
			}else{
				if(that.multipleSelection.length>0){
					for(var i in that.multipleSelection){
						organizationLicenseApplyIdsArr.push(that.multipleSelection[i].organizationLicenseApplyId);
					}
				}else{
					this.$message({
					  message: '没有选择要回退的选项哦',
					  center: true
					});
					return false;
				}
			}
			
			this.$confirm('确定要退回吗？', '提示', {
			    type: 'warning'
			}).then(() => {
			        examineOrganizationLicenseApply({
			        	isPass:2,                    
			        	organizationLicenseApplyIds: organizationLicenseApplyIdsArr              
			        }).then(res => {
			        	// 获取数据成功后的其他操作
						this.query.pageIndex = 1;
			        	this.getlistOrganizationLicenseApplyExamines();
			        	console.log(res)
			        });
			}).catch(() => {});
			
		},
        
       
       
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getlistOrganizationLicenseApplyExamines();
        }
    }
};
</script>

<style scoped>
.organ-box {
    margin-bottom: 20px;
	text-align: right;
}
.apply-box{
	display: flex;
	display: -webkit-flex;
}
.apply-box p{
	flex:1;
}
.apply-box p:last-child{
	margin-left: 20px;
}

.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

</style>
